/**
 * @function facitlitiesFilter
 * @params facilities
 * @description
 */

//  const facitlitiesFilter = (facilities)=> {

//     const detail = {};
    
//     facilities?.forEach((item, index) => {
//       item?.categories?.forEach((e) => {
//         const category = e?.category;
//         const categoryId = category?.id;
    
//         if (category?.parent_id === null) {
//           if (detail[categoryId]) {
//             if (item?.categories?.length === 1) {
//               const firstCategory = facilities?.[index]?.categories?.[0]?.category;
//               if (firstCategory) {
//                 firstCategory.parent_id = firstCategory.id;
//               }
//             }
//           }
//           detail[categoryId] = { ...e, mainIndex: item };
//         }
//       })
//     })
    
//     facilities?.forEach((item) => {
//       item?.categories?.forEach((e) => {
//         const category = e?.category;
//         const parentId = category?.parent_id;
    
//         category.min_booking_hour = item?.min_booking_hour;
//         category.booking_window = item?.booking_window;
//         category.courts = item?.courts;
//         category.facilityId = item?.id;
//         category.timings = item?.timings;
//         category.is_default_insured = item?.is_default_insured;
//         category.is_insurance = item?.is_insurance;
    
//         if (detail[parentId]) {
//           const parent = detail[parentId];
    
//           if (parent.subcategory) {
//             parent.subcategory = [...parent.subcategory, category];
    
//             if (parent.subcategoryCourtId) {
//               parent.subcategoryCourtId.push({ id: item?.id, facilityName: category?.name });
//             }
    
//             item?.courts?.forEach((court) => {
//               parent.courtFacility = {
//                 ...parent.courtFacility,
//                 [court]: item,
//               };
//             });
    
//             parent.subcategoryCourt = {
//               ...parent.subcategoryCourt,
//               [category?.name]: item?.courts,
//             };
    
//             e.discription2 = item?.description || false;
    
//             parent.subcategoryCourtInfo = {
//               ...parent.subcategoryCourtInfo,
//               [category?.name]: e,
//             };
//           } else {
//             item?.courts?.forEach((court) => {
//               parent.courtFacility = {
//                 ...parent.courtFacility,
//                 [court]: item,
//               };
//             });
    
//             parent.subcategoryCourtId = [{ id: item?.id, facilityName: category?.name }];
//             parent.subcategoryCourt = { [category?.name]: item?.courts };
//             e.discription2 = item?.description || false;
//             parent.subcategoryCourtInfo = { [category?.name]: e };
//             parent.subcategory = [category];
//           }
//         }
//       })
//     })
//     return detail
// }



 const facitlitiesFilter = (facilities)=> {

  const newFacilities = []

facilities.forEach((item)=>{
    item.categories.forEach((cat)=>{
        if(cat.category.parent_id === null && !newFacilities.some((ele)=>ele.id === cat.category.id)){    
            cat.category.subCategory = []
            newFacilities.push(cat.category)
        }
    })
})


facilities.forEach((item)=>{
    if(item.categories.length<=1){
    item.categories.forEach((cat)=>{   
                newFacilities.forEach((ele)=>{
                    if(ele.id === cat.category.id && cat.category.parent_id == null){
                        ele.subCategory = [...ele.subCategory,item]
                    }
                })
            })
        }
})


facilities.forEach((item)=>{
    item.categories.forEach((cat)=>{
        newFacilities.forEach((ele)=>{
            if(cat.category.parent_id === ele.id){
                    ele.subCategory = [...ele.subCategory,item]
            }
        })
    })
})



    return newFacilities
    
}

export default facitlitiesFilter